import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import {
    Grid,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    Paper,
    Checkbox,
    IconButton,
    TextField,
    Menu,
    MenuItem,
    Stack,
    Chip,
    Pagination,
    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Box,
    Typography,
    Tooltip
} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";

import useStyles from "../../assets/styles/SupMangComp.style";
import API from "../../utils/Axios.utils";
import useDebounce from "../../utils/useDebounce";
import { format } from "date-fns";
const ResumeListComp = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
    const config = {
        headers: { Authorization: `Bearer ${token}` },
    };

    // Pagination
    const [listCount, setListCount] = useState(0);
    const [page, setPage] = useState(1);
    const handlePageChange = (e, value) => {
        setPage(value);
    };

    // ---------- API data ----------
    const [profiles, setProfiles] = useState([]);

    // selection and filters
    const [selectedIds, setSelectedIds] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuRowId, setMenuRowId] = useState(null);
    const open = Boolean(anchorEl);

    // NEW: Applied filters state (separate from selection)
    const [appliedFilters, setAppliedFilters] = useState({
        supplier_id: null,
        core_skill_ids: [],
        date_filter: 'all'
    });

    // Supplier and skills selection (for UI only)
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [selectedCoreSkills, setSelectedCoreSkills] = useState([]);
    const [coreSkillsData, setCoreSkillsData] = useState([]);
    const [supplierData, setSupplierData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [searchText, setSearchText] = React.useState("");
    const [selectedDateFilter, setSelectedDateFilter] = useState('all');

    const getSupplier = async () => {
        setShowLoader(true);
        let url = `/api/users/getallsupplier`;

        if (searchText !== "") {
            url += `?search=${debouncedQueryList}`;
        }

        try {
            const res = await API.get(url, config);
            setShowLoader(false);
            setSupplierData(res?.data?.supplier);
        } catch (error) {
            setShowLoader(false);
        }
    };
    const debouncedQueryList = useDebounce(searchText, 500);

    useEffect(() => {
        getSupplier();
    }, [debouncedQueryList]);

    const handleSupplierChange = (event) => {
        const supplierId = event.target.value;
        const supplier = supplierData.find(s => s.supplier_id === parseInt(supplierId));
        setSelectedSupplier(supplier);
        setSelectedCoreSkills([]);
        setSelectedDateFilter('all');
        if (supplier) {
            setCoreSkillsData(supplier.coreSkills || []);
        } else {
            setCoreSkillsData([]);
        }
    };

    const handleCoreSkillChange = (event) => {
        setSelectedDateFilter('all');
        const skillIds = event.target.value;
        const selectedSkills = coreSkillsData.filter(skill => skillIds.includes(skill.id));
        setSelectedCoreSkills(selectedSkills);
    };

    // ✅ FIXED: getProfiles - Correct API param name
    const getProfiles = useCallback(async () => {
        try {
            let url = `/api/profile/allprofile?page=${page}&pageSize=10`;

            // Use APPLIED filters only
            if (appliedFilters.supplier_id) {
                url += `&supplier_id=${appliedFilters.supplier_id}`;
            }
            if (appliedFilters.core_skill_ids.length > 0) {
                const skillIds = appliedFilters.core_skill_ids.join(',');
                url += `&core_skill_ids=${skillIds}`;
            }
            // ✅ FIXED: date_filter (not date)
            if (appliedFilters.date_filter !== 'all') {
                url += `&datefilter=${appliedFilters.date_filter}`;
            }

            console.log('🔍 API URL:', url); // DEBUG

            const res = await API.get(url, config);
            setProfiles(res?.data?.profile || []);
            setListCount(res?.data?.totalCount || 0);
        } catch (error) {
            console.error('Error fetching profiles:', error);
        }
    }, [page, appliedFilters]);


    const handleDateFilterChange = (event) => {
        setSelectedDateFilter(event.target.value);
    };
    // UPDATED: handleSubmit applies filters to API
    const handleSubmit = () => {
        setAppliedFilters({
            supplier_id: selectedSupplier?.supplier_id || null,
            core_skill_ids: selectedCoreSkills.map(skill => skill.id),
            date_filter: selectedDateFilter
        });
        setPage(1);
        console.log('Applied filters:', {
            supplier_id: selectedSupplier?.supplier_id,
            supplier_org_name: selectedSupplier?.supplier_org_name,
            core_skill_ids: selectedCoreSkills.map(skill => skill.id),
        });
    };

    // ✅ FIXED: handleClearFilters - Consistent field names
    const handleClearFilters = () => {
        setSelectedSupplier(null);
        setSelectedCoreSkills([]);
        setCoreSkillsData([]);
        setSelectedDateFilter('all');
        // ✅ FIXED: Match appliedFilters structure exactly
        setAppliedFilters({
            supplier_id: null,        // ✅ Consistent
            core_skill_ids: [],       // ✅ Consistent
            date_filter: 'all'        // ✅ Consistent
        });
        setPage(1);
        console.log('🧹 Cleared all filters - API will hit without params');
    };



    // Fetch profiles only when page or appliedFilters change
    useEffect(() => {
        getProfiles();
    }, [getProfiles]);

    // Rest of handlers unchanged
    const handleToggleAll = (event, visibleRows) => {
        if (event.target.checked) {
            const allIds = visibleRows.map((r) => r.profile_id);
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };

    const handleToggleOne = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const handleMenuOpen = (event, rowId) => {
        setAnchorEl(event.currentTarget);
        setMenuRowId(rowId);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuRowId(null);
    };

    const handleDelete = (id) => {
        console.log("delete single", id);
        handleMenuClose();
    };


    const extractFileNameFromUrl = (url) => {
        if (!url) return "file";
        const parts = url.split("/");
        const lastPart = parts[parts.length - 1];
        return decodeURIComponent(lastPart.split("?")[0]); // strip query if any
    };

    const triggerDownload = (fileUrl) => {
        if (!fileUrl) return;

        const fileName = extractFileNameFromUrl(fileUrl);

        // ✅ Direct download - Works for PDF/DOC/DOCX/Images
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
        }, 100);
    };
    const handleDownload = (id) => {
        const row = profiles.find((p) => p.profile_id === id);
        if (!row?.url) {
            console.log("No URL found for profile", id);
            handleMenuClose();
            return;
        }

        triggerDownload(row.url);
        handleMenuClose();
    };






    const handleBulkDownload = async () => {
        const ids = selectedIds;
        if (ids.length === 0) return;

        try {
            const response = await API.post(
                "/api/profile/allprofile/csv",  // ← CHANGED: /zip instead of /csv
                { profile_ids: ids },
                {
                    ...config,
                    responseType: "blob"
                }
            );

            const blob = new Blob([response.data], {
                type: "application/zip"  // ← CHANGED: zip instead of csv
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "selected_resumes.zip");  // ← CHANGED: .zip
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading ZIP:", error);
        }
    };



    // REMOVED: local filtering (API handles it now)
    const allVisibleSelected =
        profiles.length > 0 &&
        profiles.every((r) => selectedIds.includes(r.profile_id));

    const someVisibleSelected =
        profiles.some((r) => selectedIds.includes(r.profile_id)) &&
        !allVisibleSelected;

    const parseStatusLabel = (status) => {
        if (!status) return "";
        return status
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
    };
    return (
        <Grid container className={classes.root}>
            {/* header + bulk actions */}
            <Grid item xs={12} className={classes.headerContainer}>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={2}
                >
                    <Grid item>
                        <h2 className={classes.pageTitle}>CV Search</h2>
                    </Grid>
                    <Grid item>
                        <Stack direction="row" spacing={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={selectedIds.length === 0}
                                onClick={handleBulkDownload}
                            >
                                Download Files
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>

            {/* UPDATED: filters section */}
            <Grid container spacing={2} className={classes.filtersSection}>
                <Grid item xs={12} md={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="supplier">Select Supplier</InputLabel>
                        <Select
                            value={selectedSupplier?.supplier_id || ''}
                            label="Select Supplier"
                            id="supplier"
                            onChange={handleSupplierChange}
                        // displayEmpty
                        >
                            {supplierData.map((supplier) => (
                                <MenuItem key={supplier?.supplier_id} value={supplier?.supplier_id}>
                                    {supplier?.supplier_org_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Select Core Skills</InputLabel>
                        <Select
                            multiple
                            value={selectedCoreSkills.map(skill => skill.id)}
                            label="Select Core Skills"
                            onChange={handleCoreSkillChange}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em>{selectedSupplier ? 'All Skills' : 'Select Supplier First'}</em>;
                                }
                                return selectedCoreSkills.map(skill => skill.name).join(', ');
                            }}
                        >
                            {coreSkillsData.map((skill) => (
                                <MenuItem key={skill.id} value={skill.id}>
                                    <Checkbox
                                        checked={selectedCoreSkills.map(s => s.id).includes(skill.id)}
                                    />
                                    <ListItemText primary={skill.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Date Filter</InputLabel>
                        <Select
                            value={selectedDateFilter}  // UI state only
                            label="Date Filter"
                            onChange={handleDateFilterChange}
                        >
                            <MenuItem value="all">All</MenuItem>
                            <MenuItem value="today">Today</MenuItem>
                            <MenuItem value="week">Last Week</MenuItem>
                            <MenuItem value="month">Last Month</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                    <Stack spacing={2} sx={{ height: '100%', justifyContent: 'space-between' }}>
                        <Stack direction="row" spacing={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                disabled={!selectedSupplier}
                                size="small"
                            >
                                Submit
                            </Button>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={handleClearFilters}
                            >
                                Clear
                            </Button>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>

            {/* table */}
            <Grid container xs={12} className={classes.tableGrid}>
                <TableContainer component={Paper}>
                    <Table
                        sx={{ minWidth: 650 }}
                        size="small"
                        aria-label="a dense table"
                    >
                        <TableHead>
                            <TableRow className={classes.tableHeadRow}>
                                <TableCell
                                    padding="checkbox"
                                    className={classes.tableHeadCell}
                                >
                                    <Checkbox
                                        indeterminate={someVisibleSelected}
                                        checked={allVisibleSelected}
                                        onChange={(e) => handleToggleAll(e, profiles)}
                                    />
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                    Candidate Name
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                    Resume
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                    Supplier
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                    Core skills
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                    Created Date
                                </TableCell>
                                <TableCell className={classes.tableHeadCell}>
                                    Status
                                </TableCell>
                                <TableCell align="right" className={classes.tableHeadCell}>
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody className={classes.noHorizontalBorderTableRow}>
                            {profiles.map((row) => (
                                <TableRow key={row.profile_id} hover>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={selectedIds.includes(row.profile_id)}
                                            onChange={() => handleToggleOne(row.profile_id)}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.tableBodyCell}>
                                        {row.candidate_name}
                                    </TableCell>
                                    <TableCell className={classes.tableBodyCell}>
                                        {row.profile_path}
                                    </TableCell>
                                    <TableCell className={classes.tableBodyCell}>
                                        {row?.supplierInfo?.supplier_org_name || "-"}
                                    </TableCell>
                                    <TableCell className={classes.tableBodyCell}>
                                        <Stack direction="row" spacing={1} flexWrap="wrap">
                                            {(row?.supplierInfo?.coreSkills || []).map((skill) => (
                                                <Chip
                                                    key={skill?.id}
                                                    size="small"
                                                    label={skill?.name || "-"}
                                                    color="default"
                                                />
                                            ))}
                                        </Stack>
                                    </TableCell>
                                    <TableCell className={classes.tableBodyCell}>
                                        {row.createdAt ? format(new Date(row.createdAt), "dd-MM-yyyy") : '-'}
                                    </TableCell>
                                    <TableCell className={classes.tableBodyCell}>
                                        <Tooltip
                                            title={parseStatusLabel(row?.detailed_status) || 'No detailed status'}
                                            arrow
                                            placement="top"
                                        >
                                            {parseStatusLabel(row?.detailed_status)}
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="left">
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleMenuOpen(e, row.profile_id)}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {profiles.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No resumes found for applied filters.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Stack
                        spacing={2}
                        sx={{
                            padding: 2,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "end",
                        }}
                    >
                        <Pagination
                            classes={{
                                root: classes.pagination,
                            }}
                            count={Math.ceil(listCount / 10)}
                            page={page}
                            onChange={handlePageChange}
                            showFirstButton
                            showLastButton
                        />
                    </Stack>
                </TableContainer>
            </Grid>

            {/* row action menu */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
            >
                <MenuItem
                    onClick={() => {
                        const row = profiles.find((p) => p.profile_id === menuRowId);
                        navigate("/admindashboard/viewFile", { state: { fileUrl: row?.url } });
                        handleMenuClose();
                    }}
                >
                    View
                </MenuItem>
                <MenuItem onClick={() => handleDownload(menuRowId)}>Download</MenuItem>
            </Menu>
        </Grid>
    );
};

export default ResumeListComp;
